import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide
} from "@mui/material";
import { forwardRef } from "react";
import UploadAvatar from "./UploadAvatar";

const Transition = forwardRef(function Transition(props: any, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AvatarModal({ showAvatarModal, toggleAvatarModal }: any) {
  return (
    <Dialog
      open={showAvatarModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={toggleAvatarModal}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1.5,
        },
      }}
    >
      <div className="w-full py-2 px-2">
        <h2 className="text-lg font-medium text-[#212121] mb-4">Actualizar foto de perfíl</h2>
  <DialogContent
        sx={{
          display: "flex",
          justifyContent: "center",
          p: 0
        }}
      >
        <UploadAvatar
          realm="tenant"
          onAction={toggleAvatarModal}
        />
      </DialogContent>
      </div>
    
      
    </Dialog>
  );
}
